import { useContext } from 'react'
import { UserContext } from './contexts'
import { useRootStore } from './rootStore'
import { useRepository } from './auth'

function useUserContext() {
  const context = useContext(UserContext)
  if (!context) {
    throw new Error('useUserContext must be used within an UserContextProvider')
  }
  return context
}

export function useBreakoutUser() {
  const context = useUserContext()

  return context.user
}

export function useImpersonatedBreakoutUser() {
  const repository = useRepository()
  const rootStore = useRootStore()

  return rootStore.impersonatedBreakoutUser(repository)
}

declare global {
  interface Window {
    _breakoutUserId: string
    _breakoutDebug: Record<string, string>
  }
}
